/**
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2023 Karmabunny
 */
import { API } from "./base";
import { NewMessage, Thread } from "../types";


const api = new API();
api.config.timeout = 100_000;


/**
 *
 */
export async function getThread(thread_uid: string) {

    const res = await api.call({
        method: 'GET',
        endpoint: `/chat/${api.config.base_entity_uid}/threads/${thread_uid}`,
    });

    return res as Thread;
}


/**
 *
 */
export async function createThread(message: NewMessage) {
    const res = await api.call({
        method: 'POST',
        endpoint: `/chat/${api.config.base_entity_uid}/threads/create`,
        body: message
    });

    return res as Thread;
}



/**
 *
 */
export async function addThreadMessage(thread_uid: string, message: NewMessage) {
    const res = await api.call({
        method: 'POST',
        endpoint: `/chat/${api.config.base_entity_uid}/threads/${thread_uid}/add`,
        body: message
    });

    return res as Thread;
}
